module.exports = __webpack_public_path__ + "img/everVision-logo.4c104ad9.svg";